// import React from "react";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";
// import { useLocation } from "react-router-dom";
// import HeroSection from "../../layout/HeroSection";
// import SecureContent from "../../components/secureContent";

// const Testing = () => {
//   const { data } = useLocation()?.state;
//   const getLink = (detail)=>{
//     if (detail?.type === "doc") {
//         return detail?.embed_link.replace("/edit", "/preview");
//       } else if (detail?.type === "slide") {
//         return detail?.embed_link.replace("/edit#slide=id.p", "/embed");
//       }
//   }

//   return (
//     <>
//       <div>
// <SecureContent/>
//   <Header />
//   <HeroSection label={<h1 class="mb-3">{data?.title ?? ""}</h1>} />
//         <div className="container">
//           <div className="row">
//             <div className="col-md-10 mx-auto untree_co-section pt-5 pb-5 ">
//               <div className=" position-relative">
//                 <iframe
//                   width="100%"
//                   height="700px"
//                   src={getLink(data)}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   {/* <img src={data.image} alt={data.title} /> */}
//                   <h5>{data.title}</h5>
//                 </iframe>

//                 <a
//                   className="ct_frame_direct_link_icon"
//                   href={data.embed_link}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <i class="fa-solid fa-up-right-from-square"></i>
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         <Footer />
//       </div>
//     </>
//   );
// };

// export default Testing;

// testing old code end--------------------


// ============ Testing.jsx ============
import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import SecureContent from "../../components/secureContent";
import { pageRoutes } from "../../routes/pageRoutes";

const Testing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    try {
      // Method 1: Check URL parameters first
      const urlData = searchParams.get('data');
      if (urlData) {
        const decodedData = JSON.parse(atob(urlData));
        setData(decodedData);
        setLoading(false);
        return;
      }

      // Method 2: Check location state
      if (location?.state?.data) {
        setData(location.state.data);
        setLoading(false);
        return;
      }

      // Method 3: Check sessionStorage
      const storedData = sessionStorage.getItem("testing_data");
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        setData(parsedData);
        setLoading(false);
        return;
      }

      // No data found
      setLoading(false);
    } catch (error) {
      console.error("Error loading data:", error);
      setLoading(false);
    }
  }, [location, searchParams]);

  const getLink = (detail) => {
    if (detail?.type === "doc") {
      return detail?.embed_link.replace("/edit", "/preview");
    } else if (detail?.type === "slide") {
      return detail?.embed_link.replace("/edit#slide=id.p", "/embed");
    }
    return detail?.embed_link;
  };


  // Show error state if no data
  if (!data) {
    return (
      <>
        <div>
          <SecureContent />
          {/* <Header />
          <HeroSection label={<h1 className="mb-3">Knowledgebase</h1>} /> */}
          <div className="container">
            <div className="row">
              <div className="col-md-10 mx-auto untree_co-section pt-5 pb-5">
                <div className="text-center">
                  <p>No data available. Please select an item from the knowledgebase.</p>
                  <div className="mb-4">
                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => navigate(pageRoutes?.knowledgebase || '/')}
                    >
                      <i className="fa-solid fa-arrow-left me-2"></i>
                      Back to Knowledgebase
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </>
    );
  }

  // Show the content
  return (
    <>
      <div>
        {/* <SecureContent /> */}
        {/* <Header />
        <HeroSection label={<h1 className="mb-3">{data?.title ?? ""}</h1>} /> */}
        <div className="container">
          <div className="row">
            <div className="col-md-10 mx-auto untree_co-section pt-5 pb-5 ">
              {/* Back Button */}
              <div className="mb-0 px-4  d-flex align-items-center justify-content-start gap-3 flex-wrap">
                {/* <a
                  href="javascript:void(0)"
                  onClick={() => navigate(-1)}
                  className=" w-auto px-3 py-3  ct_back_position"
                >
                 <i class="fa-solid fa-arrow-left me-2"></i> Back
                </a> */}
                {/* <div className="mb-4">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => navigate(pageRoutes?.knowledgebase || '/')}
                  >
                    <i className="fa-solid fa-arrow-left me-2"></i>
                    Back to Knowledgebase
                  </button>
                </div> */}

              </div>
              <div className="position-relative">
                <iframe
                  width="100%"
                  height="700px"
                  src={getLink(data)}
                  title={data.title}
                  style={{ border: "none" }}
                >
                  <h5>{data.title}</h5>
                </iframe>
                {/* <a
                  className="ct_frame_direct_link_icon"
                  href={data.embed_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa-solid fa-up-right-from-square"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default Testing;